<template>
  <svg
    class="user-circle-icon"
    xmlns="http://www.w3.org/2000/svg"
    width="103"
    height="102"
    viewBox="0 0 103 102"
    fill="none"
  >
    <g clip-path="url(#clip0_5840_9349)">
      <path
        d="M0.5 51C0.5 64.526 5.8732 77.4981 15.4376 87.0624C25.0019 96.6268 37.974 102 51.5 102C65.026 102 77.9981 96.6268 87.5624 87.0624C97.1268 77.4981 102.5 64.526 102.5 51C102.5 37.474 97.1268 24.5019 87.5624 14.9376C77.9981 5.3732 65.026 0 51.5 0C37.974 0 25.0019 5.3732 15.4376 14.9376C5.8732 24.5019 0.5 37.474 0.5 51Z"
        fill="#E9F3FF"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M51.5 54.6424C61.5594 54.6424 69.7143 46.4876 69.7143 36.4282C69.7143 26.3687 61.5594 18.2139 51.5 18.2139C41.4405 18.2139 33.2857 26.3687 33.2857 36.4282C33.2857 46.4876 41.4405 54.6424 51.5 54.6424ZM51.4996 65.571C35.93 65.571 22.4344 74.4508 15.8007 87.4216C24.9997 96.4391 37.6004 102 51.4996 102C65.3989 102 77.9996 96.4391 87.1985 87.4216C80.5649 74.4508 67.0692 65.571 51.4996 65.571Z"
        fill="#2350AC"
      />
    </g>
    <defs>
      <clipPath id="clip0_5840_9349">
        <rect width="102" height="102" fill="white" transform="translate(0.5)" />
      </clipPath>
    </defs>
  </svg>
</template>
